import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { getKeywordToolPage } from '@/components/astro/new-design-25/SEO/keyword-tool-data';
import { KeywordToolSeoPage } from '@/components/astro/new-design-25/SEO/keyword-tool-pages';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

const page = getKeywordToolPage('text-to-speech-chrome-extension');
if (!page) {
  throw new Error('Missing keyword SEO page: text-to-speech-chrome-extension');
}

export const Route = createFileRoute(
  '/_marketing/_seo/text-to-speech-chrome-extension',
)({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title: page.metaTitle,
        description: page.metaDescription,
      }),
    ],
    links: [
      {
        rel: 'canonical',
        href: normalizeCanonicalUrl('/text-to-speech-chrome-extension'),
      },
    ],
  }),
  component: () => <KeywordToolSeoPage page={page} />,
});
